<template>
	<v-dialog v-model="isVisible" max-width="900">
		<p-card class="skill-selection">
			<span
				class="tw-p-2 tw-w-full tw-text-center text-lg tw-text-white skill-title tw-block tw-mb-4"
				>{{ CHOOSE_SKILLS_MESSAGE() }} ({{ selectedOptions.length }} /
				{{ pathOr(0, ['skills', 'length'], selectedSkillGroup) }})</span
			>
			<div class="tw-flex tw-gap-4 tw-items-center tw-py-4">
				<div class="tw-flex tw-gap-4 tw-items-center tw-w-full">
					<span class="tw-text-app-color-secondary">Seleccionar {{ stepConfig.stepType }}</span>
					<v-select
						solo
						class="custom-select"
						item-text="name"
						item-value="id"
						:items="skills"
						v-model="selectedSkillGroupId"
					></v-select>
				</div>
				<div class="tw-flex tw-gap-4 tw-items-center">
					<v-checkbox
						class="custom-checkbox"
						v-model="kpiChecked"
						color="primary"
						hide-details
						:disabled="selectedOptions.some(option => option.percentageKpi > 0)"
					/>
					<span class="tw-text-app-color-secondary">KPI</span>
				</div>
				<div class="tw-flex tw-gap-4 tw-items-center" v-if="kpiChecked">
					<input
						class="new-survey-input kpi-percentage-input"
						placeholder="%"
						:style="`color: ${$appColors.info} !important`"
						:disabled="isKpiComplete && !hasSelectedSkillsInCurrentGroup"
						v-model="percentageKpi"
						type="number"
					/>%
				</div>
			</div>
			<div class="tw-text-center tw-py-2" v-if="kpiChecked">
				<div class="kpi-indicator tw-px-4 tw-py-3 tw-rounded-lg tw-border tw-transition-all tw-duration-300" :class="kpiStatusClass">
					<div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mb-2">
						<v-icon :color="totalKpiPercentage === 100 ? 'success' : totalKpiPercentage >= 50 ? 'warning' : 'error'" class="tw-text-lg">{{ kpiIcon }}</v-icon>
						<span class="tw-font-semibold tw-text-base">Progreso KPI: {{ totalKpiPercentage }}%</span>
					</div>
					<v-progress-linear :value="totalKpiPercentage" :color="totalKpiPercentage === 100 ? 'success' : totalKpiPercentage >= 50 ? 'warning' : 'error'" height="8" class="tw-rounded progress-shine"></v-progress-linear>
				</div>
			</div>
			<div class="skill-table">
				<div class="skill-table--row">
					<div></div>
					<div class="uppercase tw-text-app-color-primary">
						{{ stepConfig.stepType }}
					</div>
					<div class="uppercase tw-text-app-color-primary">definición</div>
				</div>
				<div
					v-for="(skill, index) in selectedSkillGroup.skills"
					:key="index"
					class="skill-table--row"
				>
					<div>
						<v-checkbox
							class="custom-checkbox tw-inline-block"
							@change="onCheckChange($event, skill)"
							color="primary"
							v-model="checkBoxModel[skill.id]"
							:disabled="percentageKpi === '0.00' && kpiChecked"
						/>
					</div>
					<p class="tw-m-0">{{ skill.name }}</p>
					<p class="tw-m-0">{{ skill.description }}</p>
				</div>
			</div>
			<div class="tw-text-center tw-pt-6">
				<p-button type="black" @click="close()">Cerrar</p-button>
				<p-button :disabled="isSaveDisabled" type="secondary" @click="handleSave()"
					>Guardar</p-button
				>
			</div>
		</p-card>
	</v-dialog>
</template>
<script>
import helper from '@/shared/helper';
import { find, head, pathOr, pipe, prop, propEq } from 'ramda';
import PButton from '../../../../shared/components/ui/p-button';
import PCard from '../../../../shared/components/ui/Card/p-card';
import { removeElementInList } from '../../../../shared/utils/listElements';
import { CHOOSE_SKILLS_MESSAGE } from '../../../constants/messages.constants';

export default {
	components: { PCard, PButton },
	name: 'SkillSelectionDialog',
	data() {
		return {
			isVisible: false,
			selectedOptions: [],
			selectedSkillGroupId: null,
			selectedSkillGroup: {},
			checkBoxModel: {},
			kpiChecked: false,
			percentageKpi: '0.00',
		};
	},
	props: {
		stepConfig: {
			default: () => ({
				stepType: '-',
				maxSelectedItems: 1,
				minSelectedItems: 1,
				typeKey: '',
				stepNodeName: '',
			}),
		},
		skills: {
			default: [],
		},
		selectedSkills: {
			default: () => [],
		},
	},
	computed: {
		isSaveDisabled() {
			if (!this.selectedOptions.length) return true;
			if (this.kpiChecked && this.percentageKpi === '0.00') return true;
			if (this.kpiChecked &&
				!this.selectedOptions.every(option => option.percentageKpi > 0)) return true;
			if (this.kpiChecked && !this.isKpiComplete) return true;
			return false;
		},
		totalKpiPercentage() {
			if (!this.kpiChecked) return 0;
			const groups = {};
			this.selectedOptions.forEach((option) => {
				if (option.parent && option.percentageKpi) {
					groups[option.parent.id] = option.percentageKpi;
				}
			});
			return Object.values(groups).reduce((sum, p) => sum + p, 0);
		},
		isKpiComplete() {
			return this.totalKpiPercentage === 100;
		},
		kpiStatusClass() {
			if (this.totalKpiPercentage === 100) return 'kpi-complete';
			if (this.totalKpiPercentage >= 50) return 'kpi-partial';
			return 'kpi-incomplete';
		},
		kpiIcon() {
			if (this.totalKpiPercentage === 100) return 'check_circle';
			if (this.totalKpiPercentage >= 50) return 'schedule';
			return 'error';
		},
		hasSelectedSkillsInCurrentGroup() {
			return this.selectedOptions.some(option =>
				option.parent && option.parent.id === this.selectedSkillGroupId);
		},
	},
	methods: {
		CHOOSE_SKILLS_MESSAGE() {
			return CHOOSE_SKILLS_MESSAGE;
		},
		pathOr,
		open() {
			const firstSelected = head(this.selectedSkills);
			if (firstSelected && firstSelected.parent) {
				this.selectedSkillGroupId = firstSelected.parent.id;
			} else {
				this.selectedSkillGroupId = pipe(head, prop('id'))(this.skills) || null;
			}
			this.selectedOptions = [...this.selectedSkills];
			this.checkBoxModel = {};
			this.selectedOptions.forEach((skill) => {
				this.checkBoxModel[skill.id] = true;
			});
			this.kpiChecked = this.selectedOptions.some(skill => skill.percentageKpi > 0);
			// percentageKpi will be handled by the watch on selectedSkillGroupId
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		handleSave() {
			this.$emit('onSave', this.selectedOptions);
		},
		isChecked(skillItem) {
			return this.selectedOptions.includes(skillItem);
		},
		onCheckChange(checked, option) {
			const newOption = { ...option };
			if (this.kpiChecked) {
				newOption.parent.percentageKpi = parseFloat(this.percentageKpi);
				newOption.percentageKpi = parseFloat(this.percentageKpi);
			} else {
				// Si kpiChecked está desmarcado, asegurarse de NO incluir percentageKpi
				// o establecerlo en 0/undefined según tu necesidad
				delete newOption.percentageKpi;
				if (newOption.parent) {
					delete newOption.parent.percentageKpi;
				}
			}

			if (checked) {
				this.selectedOptions = [...this.selectedOptions, newOption];
			} else {
				this.selectedOptions = removeElementInList(newOption, this.selectedOptions);
			}
			this.kpiChecked = this.selectedOptions.some(optione => optione.percentageKpi > 0);
		},
		updateSelectedOptionsWithKpi() {
			const currentGroupId = this.selectedSkillGroupId;
			this.selectedOptions = this.selectedOptions.map((option) => {
				if (option.parent && option.parent.id === currentGroupId) {
					if (this.kpiChecked) {
						return {
							...option,
							percentageKpi: parseFloat(this.percentageKpi),
							parent: {
								...option.parent,
								percentageKpi: parseFloat(this.percentageKpi),
							},
						};
					}
					const { percentageKpi, ...restOption } = option;
					const { percentageKpi: parentPercentage, ...restParent } = option.parent || {};
					return {
						...restOption,
						parent: restParent,
					};
				}
				return option;
			});
		},
	},
	watch: {
		selectedSkillGroupId(groupId) {
			this.selectedSkillGroup = find(propEq('id', groupId), this.skills);

			// Buscar si ya existen opciones seleccionadas de este grupo
			const existingOptionFromGroup = this.selectedOptions.find(
				option => option.parent && option.parent.id === groupId,
			);

			// Si existe alguna opción seleccionada de este grupo, usar su percentageKpi
			if (existingOptionFromGroup && existingOptionFromGroup.percentageKpi !== undefined) {
				this.percentageKpi = existingOptionFromGroup.percentageKpi.toFixed(2);
			} else {
				// Si no hay opciones seleccionadas de este grupo, resetear
				this.percentageKpi = '0.00';
			}
		},
		kpiChecked(val) {
			if (!val) {
				this.percentageKpi = '0.00';
			}
			this.updateSelectedOptionsWithKpi();
		},
		percentageKpi: {
			handler: helper.debounce(function percentageKpiHandler(newVal) {
				let val = parseFloat(newVal) || 0;
				val = Math.max(0, Math.min(100, val));
				val = Math.round(val * 100) / 100;
				this.percentageKpi = val.toFixed(2);
				this.updateSelectedOptionsWithKpi();
			}, 1000),
			immediate: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.skill-selection {
	p {
		color: var(--app-color-font-gray);
	}
	.skill-title {
		background-color: var(--app-color-primary);
		border-radius: 5px;
	}
	.skill-table {
		height: 40vh;
		overflow: auto;
		&--row {
			display: flex;
			border-top: 0.5px solid var(--app-color-gray);
			border-bottom: 0.5px solid var(--app-color-gray);
			padding: 10px 0 10px;
			& > :nth-child(1) {
				text-align: center;
				width: 10%;
			}
			& > :nth-child(2) {
				width: 30%;
			}
			& > :nth-child(3) {
				width: 60%;
			}

			// overriding custom checkbox style
			.custom-checkbox {
				margin: 0 !important;
				display: flex !important;
				justify-content: center !important;
				padding: 0 !important;
			}
		}
	}
	.kpi-percentage-input {
		width: 85px;
	}
	.kpi-indicator {
		border-width: 1px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		transition: all 0.3s ease;
		&.kpi-complete {
			color: var(--app-color-success) !important;
			background-color: rgba(76, 175, 80, 0.1) !important;
			border-color: var(--app-color-success) !important;
		}
		&.kpi-partial {
			color: #ff9800 !important;
			background-color: rgba(255, 152, 0, 0.1) !important;
			border-color: #ff9800 !important;
		}
		&.kpi-incomplete {
			color: var(--app-color-error) !important;
			background-color: rgba(244, 67, 54, 0.1) !important;
			border-color: var(--app-color-error) !important;
		}
	}
	.progress-shine .v-progress-linear__bar {
		position: relative;
		overflow: hidden;
		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
			animation: shine-bar 1.5s infinite;
		}
	}
	@keyframes shine-bar {
		0% {
			transform: translateX(-100%);
		}
		100% {
			transform: translateX(100%);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/second-step/components/skill-selection-dialog.vue